import { render, staticRenderFns } from "./QuotesDetail.vue?vue&type=template&id=1e3ab97a&scoped=true&"
import script from "./QuotesDetail.vue?vue&type=script&lang=js&"
export * from "./QuotesDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuotesDetail.vue?vue&type=style&index=0&id=1e3ab97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3ab97a",
  null
  
)

export default component.exports